import { render, staticRenderFns } from "./Encargo.vue?vue&type=template&id=1c5d32ca&scoped=true&"
import script from "./Encargo.vue?vue&type=script&lang=js&"
export * from "./Encargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5d32ca",
  null
  
)

export default component.exports